export default {
  title: 'Kumppanit',
  search_placeholder: 'Hae kumppania...',
  buttons: {
    default_price_list: 'Oletushinnasto',
    create_partner: 'Luo kumppani',
  },
  columns: {
    name: 'Nimi',
    restaurants: 'Ravintolat',
    shop_domain: 'Kauppa-alue',
    status: 'Tila',
    earning_enabled: 'Ansainta käytössä',
  },
  statuses: {
    invited: 'Kutsuttu',
    active: 'Aktiivinen',
    suspended: 'Keskeytetty',
  },
  actions: {
    edit: 'Muokkaa',
    view_billing: 'Näytä laskutus',
    view_as_partner: 'Näytä kumppanina',
    suspend: 'Keskeytä',
    unsuspend: 'Peru keskeytys',
  },
  suspension: {
    suspend_title: 'Keskeytetäänkö tämä kumppani?',
    suspend_description:
      'Kaikki kumppanin tiimin jäsenet poistetaan käytöstä ja heidän istuntonsa mitätöidään. Heidän ravintolansa pysyvät toiminnassa.',
    unsuspend_title: 'Perutaanko tämän kumppanin keskeytys?',
    unsuspend_description:
      'Kaikki kumppanin tiimin jäsenet aktivoidaan uudelleen ja he voivat kirjautua sisään jälleen.',
  },
  toasts: {
    load_error: 'Kumppaneita ei voitu ladata.',
    suspended: 'Kumppani on keskeytetty.',
    unsuspended: 'Kumppanin keskeytys on peruttu.',
    suspension_error: 'Kumppanin tilaa ei voitu muuttaa.',
    view_as_error: 'Kumppanin hallintapaneelia ei voitu avata.',
  },
};
